<template>
  <div class="modal-card" style="width: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        QR Code da malinha
      </p>
    </header>

    <section class="modal-card-body has-text-centered">
      <qrcode-vue :value="qrcode" size="270" level="H"></qrcode-vue>

      <p>{{ qrcode }}</p>
      <br />

      <!-- <p
        v-if="qrcode && qrcode.length > 5 && qrcode.substring(0, 5) === 'store'"
        class="has-text-danger has-text-weight-bold"
      >
        *** Atenção: Este é o QRCode da loja e não do controle de acesso ***
      </p> -->
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Fechar
      </button>
    </footer>
  </div>
</template>

<script>
import { common } from "../../mixins/common";
import QrcodeVue from "qrcode.vue";

export default {
  props: ["qrcode"],

  mixins: [common],

  components: {
    QrcodeVue
  },

  data() {
    return {
      isLoading: false
    };
  }
};
</script>
